declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    dataLayer: any[];
    gtag: (..._args: any[]) => void;
  }
}

type Environment = 'dev' | 'stg' | 'prod';

interface GTMConfig {
  ga4MeasurementId: string;
  environment: Environment;
}

interface DataLayerEvent {
  event: string;
  [key: string]: any;
}

const getEnvironment = (): Environment => {
  const envVar = import.meta.env.VITE_ENV;
  
  if (envVar === 'staging' || envVar === 'stg') {
    return 'stg';
  }
  
  if (envVar === 'production' || envVar === 'prod') {
    return 'prod';
  }
  
  return 'dev';
};

const getGTMConfig = (): GTMConfig => {
  const environment = getEnvironment();
  const ga4MeasurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID || '';

  return {
    ga4MeasurementId,
    environment,
  };
};

export const initializeDataLayer = (page: string = '/') => {
  if (typeof window === 'undefined') return;

  const config = getGTMConfig();
  
  window.dataLayer = window.dataLayer || [];
  
  window.dataLayer.push({
    app: 'culture-monitor',
    env: config.environment,
    page: page,
  });
};

export const pushToDataLayer = (event: DataLayerEvent) => {
  if (typeof window === 'undefined' || !window.dataLayer) return;
  
  window.dataLayer.push(event);
};

export const trackPageView = (page: string) => {
  const config = getGTMConfig();
  
  const eventData: DataLayerEvent = {
    event: 'page_view',
    page_path: page,
    page_location: typeof window !== 'undefined' ? window.location.href : '',
  };

  if (config.environment === 'stg') {
    eventData.debug_mode = true;
  }

  pushToDataLayer(eventData);
};

export const initializeConsentMode = () => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  
  window.dataLayer.push({
    'gtag.event': 'consent',
    'consent': {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage': 'denied',
      'functionality_storage': 'denied',
      'personalization_storage': 'denied',
      'security_storage': 'granted',
    }
  });
};

export const updateConsent = (consent: {
  ad_storage?: 'granted' | 'denied';
  ad_user_data?: 'granted' | 'denied';
  ad_personalization?: 'granted' | 'denied';
  analytics_storage?: 'granted' | 'denied';
  functionality_storage?: 'granted' | 'denied';
  personalization_storage?: 'granted' | 'denied';
  security_storage?: 'granted' | 'denied';
}) => {
  if (typeof window === 'undefined' || !window.dataLayer) return;

  window.dataLayer.push({
    'gtag.event': 'consent',
    'consent': {
      'ad_storage': consent.ad_storage || 'denied',
      'ad_user_data': consent.ad_user_data || 'denied',
      'ad_personalization': consent.ad_personalization || 'denied',
      'analytics_storage': consent.analytics_storage || 'denied',
      'functionality_storage': consent.functionality_storage || 'denied',
      'personalization_storage': consent.personalization_storage || 'denied',
      'security_storage': consent.security_storage || 'granted',
    }
  });
};

export { getGTMConfig };

